import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.aside`
  padding: 80px 0 120px 0;
  ${setFontStyle("Body8")};
  color: ${COLOR.grayScale_800};

  ${mobile(css`
    display: none;
  `)}

  ol li h4 {
    margin: 19px 0 0 8px;
  }

  h4 a {
    color: ${COLOR.grayScale_800};
  }
`;

const boardItemTitle = styled.li<{ isCurrentContents: boolean }>`
  a,
  a:visited,
  a:link {
    display: block;
    margin: 8px 0 0 16px;
    color: ${(props) =>
      props.isCurrentContents ? COLOR.primaryBlue : COLOR.grayScale_800};
    max-width: 270px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default {
  container,
  boardItemTitle,
};
